interface SVGProps {
  color: string;
  style: React.CSSProperties;
}

const SVG = ({ color, style }: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="43"
    viewBox="0 0 44 43"
    fill="none"
  >
    <g clipPath="url(#clip0_487_11879)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.833252 0H3.52101V40.3163H43.8373V43.0041H0.833252V0ZM27.7108 30.9092C27.7108 31.2656 27.8524 31.6074 28.1044 31.8595C28.3564 32.1115 28.6983 32.2531 29.0547 32.2531H39.8057C40.1621 32.2531 40.504 32.1115 40.756 31.8595C41.008 31.6074 41.1496 31.2656 41.1496 30.9092V20.1582C41.1496 19.8018 41.008 19.4599 40.756 19.2079C40.504 18.9559 40.1621 18.8143 39.8057 18.8143C39.4493 18.8143 39.1075 18.9559 38.8554 19.2079C38.6034 19.4599 38.4618 19.8018 38.4618 20.1582V27.1463L28.751 15.2745C28.6321 15.1294 28.4842 15.0108 28.3167 14.9263C28.1492 14.8418 27.9659 14.7934 27.7785 14.784C27.5912 14.7746 27.404 14.8046 27.2289 14.8719C27.0538 14.9393 26.8948 15.0426 26.762 15.1751L19.8088 22.1283L9.98237 8.61695C9.76741 8.34361 9.45487 8.16423 9.11042 8.11652C8.76597 8.0688 8.41644 8.15646 8.13527 8.36108C7.8541 8.56569 7.66319 8.87132 7.60266 9.21375C7.54213 9.55618 7.61669 9.90874 7.81067 10.1973L18.5617 24.98C18.6758 25.1372 18.8226 25.2678 18.9921 25.3628C19.1615 25.4578 19.3495 25.5149 19.5432 25.5302C19.7368 25.5455 19.9315 25.5187 20.1138 25.4516C20.296 25.3844 20.4616 25.2786 20.599 25.1413L27.6114 18.1262L36.9701 29.5653H29.0547C28.6983 29.5653 28.3564 29.7069 28.1044 29.9589C27.8524 30.211 27.7108 30.5528 27.7108 30.9092Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_487_11879">
        <rect
          width="43.0041"
          height="43.0041"
          fill={color}
          transform="translate(0.833252)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SVG;
